import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const COOKIE_KEY = "tl_cookie_notice";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 80);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const CookieNotice = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setVisible(!localStorage.getItem(COOKIE_KEY)); }, []);
  if (!visible) return null;
  const accept = () => { localStorage.setItem(COOKIE_KEY, "essential-only"); setVisible(false); };
  return (
    <div className="fixed inset-x-4 bottom-4 z-50 max-w-md rounded-lg border border-slate-200 bg-white p-4 shadow-[0_20px_50px_-20px_rgba(11,18,32,0.35)] sm:left-6 sm:right-auto sm:p-5" role="region" aria-label="Cookie notice" data-testid="cookie-notice">
      <p className="text-[13px] leading-relaxed text-slate-600 sm:text-sm">
        This website uses only essential cookies required for secure operation. We do not use analytics or advertising cookies. <Link to="/cookie-policy" className="text-[#2563EB] underline underline-offset-2">Cookie preferences</Link>
      </p>
      <button type="button" onClick={accept} className="btn-primary mt-4 h-10 px-5 text-sm" data-testid="cookie-accept-button">Understood</button>
    </div>
  );
};

export const SiteLayout = () => (
  <div className="flex min-h-screen flex-col bg-white">
    <ScrollManager />
    <Header />
    <main id="main" className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <CookieNotice />
  </div>
);
